import { useCallback, useContext } from "react";

import { PaymentMethod } from "@simplyk/common";
import { useElements, useStripe } from "@stripe/react-stripe-js";

import { PaymentErrorReport } from "./helper";

import { StripeContext } from "@/common/contexts/StripeContext";
import { useTranslate } from "@/common/hooks/useTranslate";

export const useStripePaymentReadiness = (
  selectedPaymentMethod: PaymentMethod | undefined,
  handlePaymentError: (report: PaymentErrorReport) => void
) => {
  const stripe = useStripe();
  const elements = useElements();
  const { readyPaymentElement } = useContext(StripeContext);
  const { t } = useTranslate();

  return useCallback(
    (isExpressCheckout = false) => {
      if (
        !isExpressCheckout &&
        (selectedPaymentMethod === PaymentMethod.PayPal ||
          selectedPaymentMethod === PaymentMethod.Venmo ||
          selectedPaymentMethod === PaymentMethod.Daf ||
          selectedPaymentMethod === PaymentMethod.Cash ||
          selectedPaymentMethod === PaymentMethod.Cheque)
      ) {
        return true;
      }

      const requiresPaymentElement =
        !isExpressCheckout &&
        (!selectedPaymentMethod ||
          selectedPaymentMethod === PaymentMethod.Card ||
          selectedPaymentMethod === PaymentMethod.Ach ||
          selectedPaymentMethod === PaymentMethod.Sepa);
      if (
        stripe &&
        elements &&
        (!requiresPaymentElement ||
          (readyPaymentElement !== null && readyPaymentElement === elements.getElement("payment")))
      ) {
        return true;
      }

      handlePaymentError({
        rawErrorCode: stripe && elements ? "stripe_payment_element_not_ready" : "stripe_load_error",
        rawErrorMessage: t("common", "unableToLoadStripe"),
        step: "stripe-load",
        paymentMethod: selectedPaymentMethod,
        isExpressCheckout,
        isKnownError: true,
      });
      return false;
    },
    [stripe, elements, readyPaymentElement, selectedPaymentMethod, handlePaymentError, t]
  );
};
